<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-md-5">
                  <CIcon size="sm" name="cil-building" />Kardex
                  <button @click="back" class="btn btn-sm btn-link">
                    Volver a la lista
                  </button>
                </div>
                <div class="col-12 col-md-7">
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <span v-if="person.id !== null"
                        >Estudiante :
                        <b
                          >{{ person.last_name }} {{ person.first_name }}</b
                        ></span
                      >
                    </div>
                    <!-- Pensum -->
                    <div class="col-10 col-md-4">
                      <label class="control-label" for="syllabus_id"
                        >Pensum</label
                      >
                      <b-form-select
                        v-model="columnFilter.syllabus_id"
                        :options="syllabusOptions"
                        value-field="id"
                        text-field="description"
                        id="id"
                        size="sm"
                        @change="reload"
                      >
                        <b-form-select-option :value="null"
                          >--Seleccione un pensum--</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                    <div class="col-2 col-md-2 float-right">
                      <button
                        @click="print()"
                        title="Reporte de venta"
                        class="btn btn-secondary btn-sm mt-3"
                        type="button"
                      >
                        <span><CIcon size="sm" name="cil-print" /></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No se encontraron datos de kardex"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <!-- data -->
              <template #id="{ index }">
                <td>{{ index + 1 }}</td>
              </template>
              <template #course_offered_period="{ item }">
                <td>
                  {{ item.course_offered_period | period }}
                </td>
              </template>
              <template #syllabus_description="{ item }">
                <td>
                  {{ item.syllabus_description }} Versión:
                  {{ item.syllabus_version }}
                </td>
              </template>
              <template #courses_offered_parallel="{ item }">
                <td class="text-center">
                  {{
                    item.courses_offered_parallel == "NONE"
                      ? "---"
                      : item.courses_offered_parallel
                  }}
                </td>
              </template>
              <template #final_grade="{ item }">
                <td v-if="isAdmin">
                  <span>{{ item.final_grade }}</span>
                </td>
                <td v-else>
                  <span
                    v-if="
                      item.sale_id == 0 && item.registration_tuition_price > 0
                    "
                  >
                    -</span
                  >
                  <span v-else>{{ item.final_grade }}</span>
                </td>
              </template>
              <template #observations="{ item }">
                <td v-if="isAdmin">
                  <CBadge color="success" v-if="item.observations == 'PASS'"
                    >Aprobado</CBadge
                  >
                  <CBadge color="danger" v-else-if="item.observations == 'FAIL'"
                    >Reprobado</CBadge
                  >
                  <CBadge
                    color="warning"
                    v-else-if="item.observations == 'CONDITIONED'"
                    >Condicionado</CBadge
                  >
                  <CBadge color="danger" v-else-if="item.observations == 'QUIT'"
                    >Abandono</CBadge
                  >
                  <CBadge color="secondary" v-else>No Especificado</CBadge>
                </td>
                <td v-else>
                  <span
                    v-if="
                      item.sale_id == 0 && item.registration_tuition_price > 0
                    "
                  >
                    La libreta no puede ser visualizada, debido a que tiene una
                    deuda pendiente de
                    <b
                      >Bs. {{ item.registration_tuition_price | currency }}</b
                    ></span
                  >
                  <template v-else>
                    <CBadge color="success" v-if="item.observations == 'PASS'"
                      >Aprobado</CBadge
                    >
                    <CBadge
                      color="danger"
                      v-else-if="item.observations == 'FAIL'"
                      >Reprobado</CBadge
                    >
                    <CBadge
                      color="warning"
                      v-else-if="item.observations == 'CONDITIONED'"
                      >Condicionado</CBadge
                    >
                    <CBadge
                      color="danger"
                      v-else-if="item.observations == 'QUIT'"
                      >Abandono</CBadge
                    >
                    <CBadge color="secondary" v-else>No Especifico</CBadge>
                  </template>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BAlert,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import Grades from "@/plugins/services/grades";
import Syllabus from "@/plugins/services/syllabus";
import People from "@/plugins/services/people";

export default {
  name: "DataKardex",
  components: {
    BAlert,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    TableRecords,
  },
  props: {
    student_person_id: { type: Number, required: true },
    isAdmin: { type: Boolean, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width:8px;",
        },
        {
          key: "course_offered_year",
          label: "Gestión",
          sorter: false,
          filter: false,
          _style: "width:7%;",
        },
        {
          key: "course_offered_period",
          label: "Período",
          sorter: false,
          filter: false,
          _style: "width:7%;",
        },
        {
          key: "course_name",
          label: "Curso",
          sorter: false,
          filter: false,
        },
        {
          key: "teacher_fullname",
          label: "Profesor",
          sorter: false,
          filter: false,
        },
        {
          key: "syllabus_description",
          label: "Pensum",
          sorter: false,
          filter: false,
          _style: "width:15%;",
        },
        {
          key: "courses_offered_parallel",
          label: "Paralelo",
          _style: "width:10%;",
          sorter: false,
          filter: false,
        },
        {
          key: "courses_offered_type_of_course",
          label: "Tipo",
          _style: "width:10%;",
          sorter: false,
          filter: false,
        },
        {
          key: "final_grade",
          label: "N. Final",
          _style: "width:15%;",
          sorter: false,
          filter: false,
        },
        {
          key: "observations",
          label: "Estado",
          sorter: false,
          filter: false,
          _style: "width:15%;",
        },
      ],
      const_roles: Constants.roles,
      items: [],
      columnFilter: {
        column: "id",
        asc: true,
        enabled: true,
        syllabus_id: null,
        pagination: false,
      },
      loading: true,
      syllabusOptions: [],
      person: {
        id: null,
      },
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    this.columnFilter.student_person_id = this.student_person_id;
    let roles = this.userAuth.roles;
    if (roles.length > 0) {
      roles.forEach((role) => {
        if ([this.const_roles.ROLE_STUDENT].includes(role.name)) {
          this.fields = this.fields.filter(function (field) {
            return field.key !== "teacher_fullname";
          });
        }
      });
    }
    this.getAll(this.columnFilter);
    this.getSyllabus();
    this.getPerson();
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Grades.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    // search Syllabus
    getSyllabus() {
      Syllabus.selectAllStudentSyllabus({
        student_person_id: this.student_person_id,
      })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPerson() {
      People.getOne(this.student_person_id)
        .then((res) => {
          this.person = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    print() {
      let cFilter = this.columnFilter;
      let querystring = Utils.encodeQueryData(cFilter);
      let kardexUrl = `${process.env.MIX_APP_API_ENDPOINT}/grades/kardex-pdf?${querystring}`;
      Utils.printPdf(kardexUrl);
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
